'use strict';

angular.module('app')
    .factory('PrinterConfig', ['$resource', 'ME_CONFIG', function ($resource, ME_CONFIG) {
        return $resource(ME_CONFIG.apiBaseUrl + '/printerConfig', {}, {
            'current': {method: 'GET', url: ME_CONFIG.apiBaseUrl + '/printerConfig/current'},
            'savePrinterConfig': {method: 'PUT'}
        });
    }]);